/**
 * Marketing attribution captured from the landing URL's query string.
 *
 * identityWeb models this as `MarketingParams` (enrollment/domain/marketing-params.ts): each
 * `@Prop('<query_param>')` aliases a query param onto a camelCase field, and the model's
 * `toJSON()` override *reverses* the alias table so the analytics payload is keyed by the
 * field name rather than the query param. This map is that same table in the direction the
 * parser reads it, which makes both halves of that behaviour fall out for free.
 */
export const MARKETING_PARAM_ALIASES = {
  utm_medium: 'channel',
  utm_channel: 'channelDetails',
  lob: 'lineOfBusiness',
  mktp: 'marketingPartner',
  c1: 'subPartner',
  hid: 'hitPathId',
  gid: 'googleId',
  aid: 'adobeId',
  campid: 'campaignCode',
  utm_term: 'searchTerm',
  utm_campaign: 'campaign',
  utm_content: 'topic',
  cell: 'testCell',
  creative: 'creative',
  test: 'test',
  c2: 'c2',
  c3: 'c3',
  c4: 'c4',
  billing_provider: 'billingProvider',
  campaign_code: 'campaignId',
  plan_code: 'planCode',
  offer_code: 'offerCode',
  group_code: 'groupCode',
  camp_date: 'marketingDate',
} as const;

/* `@NestedModel(Number)` on the Angular model — these arrive as strings and must be numbers. */
export const MARKETING_NUMERIC_FIELDS: string[] = ['hitPathId', 'campaignCode'];

/* `camp_date` arrives as MMDDYYYY and is stored as YYYY-MM-DD (marketing-params.ts:80-84). */
export const MARKETING_DATE_FIELD = 'marketingDate';
export const MARKETING_DATE_INPUT_FORMAT = 'MMDDYYYY';
export const MARKETING_DATE_OUTPUT_FORMAT = 'YYYY-MM-DD';

/**
 * Query params captured alongside the marketing set. identityWeb reads these in
 * `app.component.ts:122-173` (employee id, co-brand, embedded flag) and
 * `enrollment-main.component.ts:240-245` (Free Spirit number).
 */
export const MARKETING_QUERY_PARAMS = {
  employeeId: 'employee_id',
  groupCode: 'group_code',
  freeSpiritNumber: 'fsn',
  coBrand: 'cobrand',
  isEmbeddedInMobileApp: 'is-embedded-in-mobile-app',
} as const;
